import $http from '@/libs/axios'

export interface TelegramStatusResponse {
  linked: boolean;
  telegram_chat_id: string | null;
}

export interface GenerateLinkCodeResponse {
  link_code: string;
  expires_in_minutes: number;
  bot_username: string;
}

export interface UnlinkResponse {
  message: string;
  linked: false;
}

export default class UserTelegramApi {
  static async getStatus(): Promise<TelegramStatusResponse> {
    const { data } = await $http.get<TelegramStatusResponse>('user/telegram/status')
    return data
  }

  static async generateLinkCode(): Promise<GenerateLinkCodeResponse> {
    const { data } = await $http.post<GenerateLinkCodeResponse | { data: GenerateLinkCodeResponse }>('user/telegram/generate-link-code')
    const body = data as GenerateLinkCodeResponse & { data?: GenerateLinkCodeResponse }
    return body?.data ?? body
  }

  static async unlink(): Promise<UnlinkResponse> {
    const { data } = await $http.post<UnlinkResponse>('user/telegram/unlink')
    return data
  }

  static async destinations() {
    return (await $http.get('user/telegram/destinations')).data
  }

  static async refreshDestinations() {
    return (await $http.post('user/telegram/destinations/refresh')).data
  }

  static async verifyDestination(chat: string) {
    return (await $http.post('user/telegram/destinations/verify', { chat })).data
  }

  static async botStatus() {
    return (await $http.get('user/telegram/bot')).data
  }

  static async saveBot(botToken: string) {
    return (await $http.post('user/telegram/bot', { bot_token: botToken })).data
  }

  static async removeBot() {
    return (await $http.delete('user/telegram/bot')).data
  }
}
